import { useEffect, useState } from "react";
import { buscarInteressadoAnuncioByUsuarioId } from "../../../services/buscarInteressadoAnuncioByUsuarioIdService";

export const useInteressadoAnuncio = (
  usuarioId: number | null,
  isModalOpen: boolean
) => {
  const [interessadoAnuncio, setInteressadoAnuncio] = useState<any | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      if (usuarioId && isModalOpen) {
        setLoading(true);
        try {
          const data = await buscarInteressadoAnuncioByUsuarioId(usuarioId);

          setInteressadoAnuncio(data.length);
        } catch (err) {
          console.error("Erro ao buscar interesse do anuncio:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetch();
  }, [usuarioId, isModalOpen]);

  return { interessadoAnuncio, loading };
};
